import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import routes from './routes.js';



const router = new VueRouter({
  routes
});

Vue.config.productionTip = false;


new Vue({
  render: h => h(App),
  router
}).$mount('#app');
